import { FormControlLabel, Grid, Switch } from "@mui/material";
import { useStyles } from "../NotificationsModal.styles";

export const NotificationSwitch = ({
    margin,
    isEnabled,
    name,
    size,
    handleChange,
}: {
    margin?: boolean;
    isEnabled: boolean;
    name: string;
    size: number;
    handleChange: () => Promise<void>;
}) => {
    const classes = useStyles();

    return (
        <Grid style={margin ? { marginLeft: "20px" } : {}} className={classes.container} item xs={size}>
            <FormControlLabel
                className={classes.switchLabel}
                value="start"
                control={
                    <Switch
                        checked={isEnabled}
                        className={classes.switch}
                        onChange={async (e) => {
                            await handleChange();
                        }}
                    />
                }
                label={name}
                labelPlacement="start"
            />
        </Grid>
    );
};
